var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-failure" },
    [
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false, closeOnClickOverlay: "true" },
          on: { close: _vm.close },
          model: {
            value: _vm.showCheckFailureDia,
            callback: function ($$v) {
              _vm.showCheckFailureDia = $$v
            },
            expression: "showCheckFailureDia",
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "tit" }, [
              _vm._v(_vm._s(_vm.$t("lang.wd.state1"))),
            ]),
            _c("div", {
              staticClass: "con",
              domProps: {
                innerHTML: _vm._s(_vm.$t("lang.check.checkFailureCon")),
              },
            }),
            _c("div", { staticClass: "btn", on: { click: _vm.close } }, [
              _vm._v(_vm._s(_vm.$t("lang.gotit"))),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }